import { jsxs as e, jsx as p } from "react/jsx-runtime";
import { u as r } from "../index-DvpE_B3z.js";
import { Button as o } from "../shared/button/Button.component.js";
import { ButtonShapeEnum as l, ButtonSizeEnum as s, ButtonThemeEnum as i } from "../shared/button/types.js";
import { BrowseFilesIcon as u } from "./icons/BrowseFiles.icon.js";
import { FilesEmptyIcon as c } from "./icons/FilesEmpty.icon.js";
const B = ({
  copies: t
}) => {
  const { getRootProps: a, getInputProps: n, open: m } = r({
    multiple: !0,
    noClick: !0
  });
  return /* @__PURE__ */ e(
    "div",
    {
      ...a(),
      className: "app:flex app:flex-col app:justify-center app:items-center app:gap-4",
      children: [
        /* @__PURE__ */ p(c, {}),
        /* @__PURE__ */ p("span", { className: "app:text-stone-400", children: t == null ? void 0 : t.fileExplorer.emptyState.description }),
        /* @__PURE__ */ p("input", { ...n(), className: "app:hidden" }),
        /* @__PURE__ */ p(
          o,
          {
            type: "button",
            className: "app:[--button--padding:0px] app:[--button--min-width--sm:0px] app:my-10 app:mx-auto",
            theme: i.outline,
            size: s.sm,
            shape: l.pill,
            onClick: m,
            children: /* @__PURE__ */ e("div", { className: "app:flex app:gap-2 app:items-center", children: [
              /* @__PURE__ */ p(u, { className: "app:w-5 app:h-5" }),
              /* @__PURE__ */ p("span", { children: t == null ? void 0 : t.fileExplorer.emptyState.browseButton })
            ] })
          }
        )
      ]
    }
  );
};
export {
  B as EmptyFilesState
};
